<template>
  <div>
    <v-dialog :value="value" content-class="view-post-modal"  @input="$emit('input')" max-width="1200px" :fullscreen="$vuetify.breakpoint.xsOnly">
      <v-card v-if="postData !== null">
        <v-toolbar dense class="elevation-2">
          <v-spacer></v-spacer>
          <v-toolbar-title>
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <div class="text-no-wrap font-weight-bold" v-on="on">{{postData.campaignName}} Campaign</div>
            </template>
            <span v-if="currentUserRole !== userRoles.CLIENT">Submitted as <strong>{{postData.submittedCampaignName || postData.campaignName + ' (Unverified)'}}</strong></span>
          </v-tooltip>
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click="closeModal"><v-icon>close</v-icon></v-btn>
        </v-toolbar>
        <v-container fluid class="view-post-modal__body">
          <v-row v-if="postHistoryData.length > 0">
            <v-col class="text-right">
              <v-btn class="secondary" @click="viewPostDetails()">
                Details
              </v-btn>
            </v-col>
          </v-row>
          <v-row>
            <v-col md="3" xs="12" v-if="postAbuseHistory && postHistoryData.length > 0">
              <!-- Draft History -->
              <v-flex>
                <v-card height="100%">
                  <v-card-title class="title">
                    Draft History
                  </v-card-title>
                  <v-card-text>
                    <v-list dense>
                      <template v-for="(hpost, i) in postHistoryData">
                        <v-list-item
                          :key="hpost._id + i"
                          @click="switchPostView(hpost)"
                        >
                          <v-list-item-content>
                            <v-list-item-title v-if="hpost.editedBy">
                              {{hpost.editedBy.name}}
                            </v-list-item-title>
                            <v-list-item-title>
                              {{ hpost.isMain == null ? `${formatDate(hpost.createdAt)} (Active)` : formatDate(hpost.createdAt)}}
                            </v-list-item-title>
                            <v-list-item-title v-if="hpost.abuse_resolved">
                              (Pending Abuse Resolved)
                            </v-list-item-title>
                          </v-list-item-content>
                          <v-list-item-action v-if="hpost._id === postData._id">
                            <v-icon color="green">check_circle</v-icon>
                          </v-list-item-action>
                          <v-list-item-action v-if="hpost._id !== postData._id && hpost._id === post.mainPost._id">
                            <v-tooltip float-right>
                              <template v-slot:activator="{ on }">
                                <v-icon color="grey" v-on="on">check_circle_outline</v-icon>
                              </template>
                              <span>Influencer & Client will see this version of draft.</span>
                            </v-tooltip>
                          </v-list-item-action>
                        </v-list-item>
                      </template>
                    </v-list>
                  </v-card-text>
                  <v-card-actions>
                    <v-row cols="12">
                      <v-col xs="12">
                        <v-btn block class="secondary" @click="setPrimaryPost(postData._id)">
                          Change to this version
                        </v-btn>
                      </v-col>
                      <v-col class="pt-0" xs="12" v-if="postData.status <= postStatusConfig.CLIENT_PENDING && postData.abuse_resolved && saleActions">
                        <v-btn block class="success" @click="releaseAbuseResolvedPosts([postData._id])">
                          Release to Client
                          <v-icon float-right>done_all</v-icon>
                        </v-btn>
                      </v-col>
                    </v-row>
                  </v-card-actions>
                </v-card>
              </v-flex>
            </v-col>
            <v-col :md="mainViewGrid" xs="12">
              <v-card outlined>
                <v-card-text>
                  <div v-if="influencerData && !mappedInfluencerData">
                    <div>
                      <v-row cols="12">
                        <v-col xs="6">
                          <div v-if="postData.influencers && postData.influencers.length > 1  && this.currentUserRole <= userRoles.AD_STRATEGIST">
                            <v-menu
                              bottom
                              origin="center center"
                              transition="scale-transition"
                              v-if="postData.defaultInf"
                            >
                              <template v-slot:activator="{ on, attrs }">
                                <v-btn
                                  dark
                                  text
                                  v-bind="attrs"
                                  v-on="on"
                                >
                                  <!-- <v-avatar size="35" color="grey lighten-4">
                                    <img
                                      class="elevation-6"
                                      v-bind:src="paserImageUrl(postData.defaultInf.picture)"
                                      alt="avatar"
                                    >
                                  </v-avatar> -->
                                  <a
                                    :href="'https://www.tiktok.com/@' + postData.defaultInf.handle"
                                    target="_blank"
                                    v-if="postData.defaultInf.tiktok"
                                  ><img src="/static/img/tiktok-32.png" width="20px" /> @{{postData.defaultInf.handle}}</a>
                                  <a
                                    :href="'https://youtube.com/' + postData.defaultInf.handle"
                                    target="_blank"
                                    v-else-if="postData.defaultInf.youtube"
                                  ><v-icon>mdi-youtube</v-icon> @{{postData.defaultInf.handle}}</a>
                                  <a
                                    :href="'https://instagram.com/' + postData.defaultInf.handle"
                                    target="_blank"
                                    v-else
                                  ><v-icon color="#000000" small>mdi-instagram</v-icon> @{{postData.defaultInf.handle}}</a>
                                  <v-icon class="ml-2" color="secondary" small>mdi-chevron-down-circle</v-icon>
                                </v-btn>
                              </template>
                              <v-list>
                                <v-list-item
                                  v-for="(obj, i) in postData.influencers"
                                  :key="i"
                                  link
                                  @click="changePlatform(obj, i)"
                                >
                                  <v-list-item-title>
                                    <!-- <v-avatar size="35" color="grey lighten-4">
                                      <img
                                        class="elevation-6"
                                        v-bind:src="paserImageUrl(obj.picture)"
                                        alt="avatar"
                                      >
                                    </v-avatar> -->
                                    <a
                                      v-if="obj.tiktok"
                                    ><img src="/static/img/tiktok-32.png" width="20px" /> @{{obj.handle}}</a>
                                    <a
                                      v-else-if="obj.youtube"
                                    ><v-icon>mdi-youtube</v-icon> @{{obj.handle}}</a>
                                    <a
                                      v-else
                                    ><v-icon color="#000000" small>mdi-instagram</v-icon> @{{obj.handle}}</a>
                                  </v-list-item-title>
                                </v-list-item>
                              </v-list>
                            </v-menu>
                          </div>
                          <div v-else>
                            <!-- <v-avatar size="35" color="grey lighten-4">
                              <img
                                class="elevation-6"
                                v-bind:src="paserImageUrl(influencerData.profilePicture)"
                                alt="avatar"
                              >
                            </v-avatar> -->
                            <a
                              :href="'https://www.tiktok.com/@' + influencerData.username"
                              target="_blank"
                              v-if="influencerData.platform==='tiktok'"
                            ><img src="/static/img/tiktok-32.png" width="20px" /> @{{influencerData.username}}</a>
                            <a
                              :href="'https://youtube.com/' + influencerData.username"
                              target="_blank"
                              v-else-if="influencerData.platform==='youtube'"
                            ><v-icon>mdi-youtube</v-icon> @{{influencerData.username}}</a>
                            <a
                              @click="openLink('https://www.xiaohongshu.com/user/profile/' + influencerData.username)"
                              v-else-if="influencerData.platform==='xiaohongshu'"
                            >{{influencerData.username}}</a>
                            <a
                              :href="'https://www.linkedin.com/in/' + influencerData.username"
                              target="_blank"
                              rel="noopener noreferrer"
                              v-else-if="influencerData.platform==='linkedin'"
                            ><v-icon color="#0A66C2" small>mdi-linkedin</v-icon> @{{influencerData.username}}</a>
                            <a
                              :href="'https://x.com/' + influencerData.username"
                              target="_blank"
                              rel="noopener noreferrer"
                              v-else-if="postData.type === 'twitter' || influencerData.platform === 'twitter'"
                            ><img src="/static/img/x-logo.svg" width="15px" alt="" aria-hidden="true"> @{{influencerData.username}}</a>
                            <a
                              :href="'https://instagram.com/' + influencerData.username"
                              target="_blank"
                              v-else
                            ><v-icon color="#000000" small>mdi-instagram</v-icon> @{{influencerData.username}}</a>
                          </div>
                        </v-col>
                        <v-col xs="6" class="text-right" v-if="currentUserRole !== userRoles.CLIENT">
                          <!-- For others, except admin, client -->
                          <v-chip
                            color="primary"
                            v-if="postData.type"
                          >
                            <img
                              v-if="getPostTypeMeta(postData.type).imgIcon"
                              :src="getPostTypeMeta(postData.type).imgIcon"
                              width="15px"
                              height="15px"
                              class="mr-1"
                              style="object-fit: contain;"
                              alt=""
                              aria-hidden="true"
                            >
                            <v-icon
                              v-else
                              small
                              class="mr-1"
                              :style="`color: ${getPostTypeMeta(postData.type).iconColor || '#ffffff'} !important;`"
                            >{{ getPostTypeMeta(postData.type).icon }}</v-icon>
                            {{ postData.type | platformDisplayName }}
                          </v-chip>
                          <v-menu
                            v-if="postData.type"
                            bottom
                            origin="center center"
                            transition="scale-transition"
                          >
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn
                                dark
                                text
                                v-bind="attrs"
                                v-on="on"
                                style="min-width:0;padding:0;margin-left:-5px;"
                              >
                                <v-icon class="ml-2" color="secondary" v-on="on" small>mdi-chevron-down-circle</v-icon>
                              </v-btn>
                            </template>
                            <v-list>
                              <v-list-item
                                v-for="(obj, i) in postTypes"
                                :key="i"
                                link
                                @click="changePostType(obj)"
                              >
                                <v-list-item-icon class="mr-3">
                                  <img
                                    v-if="obj.imgIcon"
                                    :src="obj.imgIcon"
                                    width="20px"
                                    height="20px"
                                    style="object-fit: contain;"
                                    alt=""
                                    aria-hidden="true"
                                  >
                                  <v-icon
                                    v-else
                                    size="20"
                                    :style="`color: ${obj.iconColor || '#616161'} !important;`"
                                  >{{ obj.icon }}</v-icon>
                                </v-list-item-icon>
                                <v-list-item-title>
                                  {{ obj.type | platformDisplayName }}
                                </v-list-item-title>
                              </v-list-item>
                            </v-list>
                          </v-menu>
                        </v-col>
                      </v-row>
                    </div>
                  </div>
                  <div v-if="mappedInfluencerData && this.currentUserRole <= userRoles.AD_STRATEGIST">
                    <v-row cols="12">
                      <v-col xs="6">
                        <!-- <v-avatar size="35" color="grey lighten-4">
                          <img
                            class="elevation-6"
                            v-bind:src="mappedInfluencerData.picture"
                            alt="avatar"
                          >
                        </v-avatar> -->
                        <a
                          :href="'https://tiktok.com/' + mappedInfluencerData.tiktokHandle"
                          target="_blank"
                          v-if="mappedInfluencerData.tiktokHandle"
                        ><img src="/static/img/tiktok-32.png" width="20px" /> @{{mappedInfluencerData.tiktokHandle}}</a>
                        <a
                          :href="'https://youtube.com/' + mappedInfluencerData.youtubeHandle"
                          target="_blank"
                          v-else-if="mappedInfluencerData.youtubeHandle"
                        ><v-icon>mdi-youtube</v-icon> @{{mappedInfluencerData.youtubeHandle}}</a>
                        <a
                          :href="'https://www.linkedin.com/in/' + mappedInfluencerData.linkedinHandle"
                          target="_blank"
                          rel="noopener noreferrer"
                          v-else-if="mappedInfluencerData.linkedinHandle"
                        ><v-icon color="#0A66C2" small>mdi-linkedin</v-icon> @{{mappedInfluencerData.linkedinHandle}}</a>
                        <a
                          :href="'https://x.com/' + (mappedInfluencerData.twitterHandle || mappedInfluencerData.instagramHandle)"
                          target="_blank"
                          rel="noopener noreferrer"
                          v-else-if="postData.type === 'twitter' || mappedInfluencerData.twitterHandle"
                        ><img src="/static/img/x-logo.svg" width="15px" alt="" aria-hidden="true"> @{{mappedInfluencerData.twitterHandle || mappedInfluencerData.instagramHandle}}</a>
                        <a
                          :href="'https://instagram.com/' + mappedInfluencerData.instagramHandle"
                          target="_blank"
                          v-else
                        ><v-icon color="#000000" small>mdi-instagram</v-icon> @{{mappedInfluencerData.instagramHandle}}</a>
                      </v-col>
                      <v-col xs="6" class="text-right">
                        <!-- For Admins -->
                        <v-chip
                          color="primary"
                          v-if="postData.type"
                        >
                          <img
                            v-if="getPostTypeMeta(postData.type).imgIcon"
                            :src="getPostTypeMeta(postData.type).imgIcon"
                            width="15px"
                            height="15px"
                            class="mr-1"
                            style="object-fit: contain;"
                            alt=""
                            aria-hidden="true"
                          >
                          <v-icon
                            v-else
                            small
                            class="mr-1"
                            :style="`color: ${getPostTypeMeta(postData.type).iconColor || '#ffffff'} !important;`"
                          >{{ getPostTypeMeta(postData.type).icon }}</v-icon>
                          {{ postData.type | platformDisplayName }}
                        </v-chip>
                        <v-menu
                          v-if="postData.type"
                          bottom
                          origin="center center"
                          transition="scale-transition"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                              dark
                              text
                              v-bind="attrs"
                              v-on="on"
                              style="min-width:0;padding:0;margin-left:-5px;"
                            >
                              <v-icon class="ml-2" color="secondary" v-on="on" small>mdi-chevron-down-circle</v-icon>
                            </v-btn>
                          </template>
                          <v-list>
                            <v-list-item
                              v-for="(obj, i) in postTypes"
                              :key="i"
                              link
                              @click="changePostType(obj)"
                            >
                              <v-list-item-icon class="mr-3">
                                <img
                                  v-if="obj.imgIcon"
                                  :src="obj.imgIcon"
                                  width="20px"
                                  height="20px"
                                  style="object-fit: contain;"
                                  alt=""
                                  aria-hidden="true"
                                >
                                <v-icon
                                  v-else
                                  size="20"
                                  :style="`color: ${obj.iconColor || '#616161'} !important;`"
                                >{{ obj.icon }}</v-icon>
                              </v-list-item-icon>
                              <v-list-item-title>
                                {{ obj.type | platformDisplayName }}
                              </v-list-item-title>
                            </v-list-item>
                          </v-list>
                        </v-menu>
                      </v-col>
                    </v-row>
                    <v-row cols="12">
                      <v-col v-if="influencerData" class="text-center">
                        <p>
                        Submitted By:
                        <!-- <v-avatar size="35" color="grey lighten-4">
                          <img
                            class="elevation-6"
                            v-bind:src="paserImageUrl(influencerData.profilePicture)"
                            alt="avatar"
                          >
                        </v-avatar> -->
                        <a
                          :href="'https://www.tiktok.com/@' + influencerData.username"
                          target="_blank"
                          v-if="influencerData.platform==='tiktok'"
                        ><img src="/static/img/tiktok-32.png" width="20px" /> @{{influencerData.username}}</a>
                        <a
                          :href="'https://youtube.com/' + influencerData.username"
                          target="_blank"
                          v-else-if="influencerData.platform==='youtube'"
                        ><v-icon>mdi-youtube</v-icon> @{{influencerData.username}}</a>
                        <a
                          :href="'https://www.linkedin.com/in/' + influencerData.username"
                          target="_blank"
                          rel="noopener noreferrer"
                          v-else-if="influencerData.platform==='linkedin'"
                        ><v-icon color="#0A66C2" small>mdi-linkedin</v-icon> @{{influencerData.username}}</a>
                        <a
                          :href="'https://x.com/' + influencerData.username"
                          target="_blank"
                          rel="noopener noreferrer"
                          v-else-if="postData.type === 'twitter' || influencerData.platform === 'twitter'"
                        ><img src="/static/img/x-logo.svg" width="15px" alt="" aria-hidden="true"> @{{influencerData.username}}</a>
                        <a
                          :href="'https://instagram.com/' + influencerData.username"
                          target="_blank"
                          v-else
                        ><v-icon color="#000000" small>mdi-instagram</v-icon> @{{influencerData.username}}</a>
                        </p>
                      </v-col>
                    </v-row>
                  </div>
                  <div v-if="showCutOffView">
                    <v-row class="pb-0" cols="12">
                      <v-col class="pb-0" xs="12">
                        <v-switch
                          class="float-right"
                          v-model="isTikTokCutOff"
                          label="Preview Tiktok"
                          @change="changeCutOff('tiktok')"
                        ></v-switch>
                        <v-switch
                        class="float-right pr-4"
                        v-model="isIGStory"
                        label="Preview IG Story"
                        @change="changeCutOff('IGStory')"
                      ></v-switch>
                        <v-switch
                          class="float-right pr-5"
                          v-model="isIGCutOff"
                          label="Preview IG Reel"
                          @change="changeCutOff('IG')"
                        ></v-switch>
                      </v-col>
                    </v-row>
                  </div>

                  <v-container grid-list-sm container--fluid>
                    <v-alert
                      :value="images.length === 0"
                      color="secondary" icon="secondary"
                      outlined
                    >
                      No Media found for this post.
                    </v-alert>
                    <v-layout row wrap justify-center justify-space-around v-if="images !== undefined">
                      <v-flex v-for="(img, imageIndex) in images" :key="img && img.url ? img.url : `missing-media-${imageIndex}`" md4 xs12>
                        <v-card class="mb-3" text tile v-if="isMissingMedia(img)">
                          <v-alert type="warning" outlined class="mb-0">
                            This media file is missing. Edit the draft and upload it again.
                          </v-alert>
                        </v-card>
                        <v-card class="mb-3" text tile v-else-if="img.publicID && img.isvideo">
                          <custom-media-v2
                            :media="campaignHelper.customPostMediaConfig(img, { videoDownload: true, overlay: true, overlayType, postView: true })"
                          />
                        </v-card>
                        <v-card class="mb-3" style="max-width:258px" text tile v-else-if="img.isvideo && img.url.includes('s3-ap-southeast-1')">
                          <custom-media-v2
                            :media="campaignHelper.customPostMediaConfig(img, { videoDownload: true, overlay: true, overlayType, postView: true })"
                          />
                        </v-card>
                        <v-card text tile v-else>
                          <v-hover v-if="!img.isvideo">
                            <div
                              class="cursor-pointer"
                              @click="viewMedia(img)"
                              v-if="img.publicID">
                              <custom-media-v2
                                :media="campaignHelper.customPostMediaConfig(img, { trans: { width: 320, crop: 'scale' }, overlay: true, overlayType })"
                              />
                            </div>
                            <v-img
                              :src="img.thumbnail || img.url"
                              :lazy-src="img.url"
                              aspect-ratio="1"
                              class="grey lighten-2 mx-auto"
                              slot-scope="{ hover }"
                              :class="`elevation-${hover ? 12 : 2}`"
                              @click="viewMedia(img.url, img.video)"
                              v-else
                            />
                          </v-hover>
                          <div v-if="img.isvideo" class="elevation-8">
                            <video id="previewVideo" width="100%" controls>
                              <source :src="img.url" type="video/mp4">
                              Your browser does not support the video tag.
                            </video>
                          </div>
                        </v-card>
                        <!-- <btn-download :url="img.url" v-if="img.type === 'video/quicktime'"></btn-download> -->
                      </v-flex>
                    </v-layout>
                  </v-container>
                  <div class="body-1" v-if="postData.captionText">
                    <v-textarea
                      class="post-caption-textarea"
                      readonly
                      filled
                      auto-grow
                      rows="4"
                      :label="captionLabel"
                      v-model="postData.captionText"
                      counter
                      >
                    </v-textarea>
                  </div>
                  <div v-if="isVideoLink">
                    <!-- <v-text-field
                      readonly
                      filled
                      type="text"
                      label="Link"
                      :value="postData.vdoLink"
                      >
                    </v-text-field> -->
                    <div v-if="postData.vdoLink" class="caption-label">
                      Link
                    </div>
                    <div v-if="postData.vdoLink" class="caption-text">
                      <span class="caption-text__value">{{postData.vdoLink}}</span>
                      <v-btn
                        v-if="getVideoLink(postData.vdoLink)"
                        :href="getVideoLink(postData.vdoLink)"
                        target="_blank"
                        rel="noopener noreferrer"
                        icon
                        x-small
                        color="secondary"
                        title="Open video link"
                      >
                        <v-icon small>mdi-open-in-new</v-icon>
                      </v-btn>
                    </div>
                  </div>

                  <div class="body-1" v-if="isRemark">
                    <div class="kobe-remark-display">
                      <div class="kobe-remark-display__label">Kobe Remark</div>
                      <div v-html="renderHTML(postData.remark)"></div>
                    </div>
                  </div>

                  <div class="body-1" v-if="isHashTag">
                    <v-textarea
                      readonly
                      filled
                      auto-grow
                      rows="4"
                      label="Mandatory Hashtag & Mentions"
                      v-model="postData.mandatoryHashtag"
                      counter
                      >
                    </v-textarea>
                  </div>

                  <div class="body-1" v-if="isCallToActionLinks">
                    <v-textarea
                      readonly
                      filled
                      auto-grow
                      rows="4"
                      label="Call to Action Links"
                      v-model="postData.callToActionLinks"
                      counter
                      >
                    </v-textarea>
                  </div>

                  <v-layout row wrap justify-center style="margin-top:20px;">
                    <div xs12 md6 v-if="postData.postDate">
                      <v-chip label class="subheading ma-1">
                        <span>Scheduled:&nbsp;</span>
                        <strong>{{postData.postDate}}</strong>
                        <strong>{{postData.postDateEnd ? `&nbsp; to ${postData.postDateEnd}` : ''}}</strong>
                      </v-chip>
                    </div>
                    <div xs12 md6>
                      <v-chip label class="subheading ma-1">
                        <span>Status:&nbsp;</span>
                        <strong>{{postStatusDisplay}}</strong>
                      </v-chip>
                    </div>
                    <div xs12 md6 v-if="postData.abuse_resolved || postData.release_abuse_resolved">
                      <v-chip label class="subheading ma-1">
                        <v-icon color="green">check</v-icon> <span>Abuse Resolved</span>
                      </v-chip>
                    </div>
                    <div xs12 md12 v-if="postData.postURL">
                      <v-chip label class="subtitle-1 ma-1">
                        <v-avatar><v-icon>link</v-icon></v-avatar>
                        <strong><a :href="postData.postURL" target="_blink">View Live Post</a></strong>
                      </v-chip>
                    </div>
                  </v-layout>
                  <v-layout row wrap justify-center style="margin-top:20px;">
                    <div xs12 md6 v-if="postData.requestDate">
                      <v-chip label class="subheading-1 ma-1">
                        <span>Request Date:&nbsp;</span>
                        <strong>{{postData.requestDate}}</strong>
                      </v-chip>
                    </div>
                    <div xs12 md6 v-if="postData.requestDate && postData.propose_dates">
                      <v-chip label class="subheading-1 ma-1">
                        <span>Propose Dates:&nbsp;</span>
                        <strong>{{postData.propose_dates.map(p => p).join(', ')}}</strong>
                      </v-chip>
                    </div>
                  </v-layout>
                  <!-- Request Date Actions for CS -->
                  <v-card-actions class="mt-2" style="justify-content:center" v-if="proposeDateActions">
                    <v-btn small text color="secondary" @click="openProposeDateDialog()" v-if="overRideBySuperAdmin || (postData.status === postStatusConfig.APPROVE && postData.requestDate)">
                      Propose new Dates
                      <v-icon small float-right>edit</v-icon>
                    </v-btn>
                    <v-btn small text color="success" @click="invokeConfirmDateChange">
                      Confirm Date
                      <v-icon small float-right>check</v-icon>
                    </v-btn>
                  </v-card-actions>
                  <v-divider></v-divider>
                  <!-- Actions For Influencer -->
                  <v-card-actions v-if="influencerActions">
                    <v-spacer></v-spacer>
                    <v-btn small text color="secondary" @click="edit()">
                      Edit Draft
                      <v-icon float-right>edit</v-icon>
                    </v-btn>
                    <v-spacer></v-spacer>
                  </v-card-actions>
                  <!-- Actions For CS -->
                  <v-card-actions v-if="overRideBySuperAdmin ? overRideBySuperAdmin : csActions">
                    <v-spacer></v-spacer>
                    <v-btn small text color="secondary" @click="edit()">
                      Edit Draft
                      <v-icon float-right>edit</v-icon>
                    </v-btn>
                    <v-btn small text color="secondary" @click="editLiveDate()">
                      Edit Live Date
                      <v-icon float-right>edit</v-icon>
                    </v-btn>
                    <v-btn v-if="postData.status !== postStatusConfig.CLIENT_PENDING && postData.status !== postStatusConfig.APPROVE" small text color="green" @click="approve()">
                      Submit Draft to AM
                      <v-icon right>check</v-icon>
                    </v-btn>
                    <v-btn small text color="secondary" @click="markMetadataTag([postData._id])" v-if="postData.status >= postStatusConfig.CLIENT_PENDING && !postData.metadataTagged">
                      Mark As Metadata Tagged
                      <v-icon float-right>check</v-icon>
                    </v-btn>
                    <v-btn small text color="secondary" @click="abuseResolvePosts([postData._id])" v-if="postData.status >= postStatusConfig.CLIENT_PENDING && isIncludeInAbuseReport(postData._id, clientReportAbuseData) && !postData.abuse_resolved && !postData.release_abuse_resolved">
                      Mark As Abuse Resolved
                      <v-icon float-right>check</v-icon>
                    </v-btn>
                    <!-- <v-btn small text color="secondary" @click="releaseAbuseResolvedPosts([postData._id])" v-if="postData.abuse_resolved">
                      Release Abuse Resolved
                      <v-icon float-right>done_all</v-icon>
                    </v-btn> -->
                    <v-btn v-if="postData.status === postStatusConfig.AD_STRATEGIST_PENDING && postData.campaignID && campaign.campaignType !== campaignTypes.STORY_TELL" small text color="green" @click="directRelease()">
                      Direct Release to Client
                      <v-icon right>check</v-icon>
                    </v-btn>
                    <v-spacer></v-spacer>
                  </v-card-actions>
                  <!-- Actions For Sale Person -->
                  <v-card-actions v-if="overRideBySuperAdmin ? overRideBySuperAdmin : saleActions">
                    <v-spacer></v-spacer>
                    <v-btn small text color="secondary" @click="releaseAbuseResolvedPosts([postData._id])" v-if="postData.abuse_resolved">
                      Release to Client
                      <v-icon float-right>done_all</v-icon>
                    </v-btn>
                    <v-btn v-if="(postData.status === postStatusConfig.AD_STRATEGIST_PENDING && postData.waiting_release)" small text color="green" @click="release()">
                      Release to Client
                      <v-icon right>check</v-icon>
                    </v-btn>
                    <v-spacer></v-spacer>
                  </v-card-actions>
                  <!-- Actions For Client -->
                  <v-card-actions v-if="clientReportAbuse.length < 1 && clientActions">
                    <v-spacer></v-spacer>
                    <v-btn
                      color="indigo"
                      dark
                      :to="{name:'posts-submission-review', query: {id: postData._id}}"
                      v-if="!postData.propose_dates && postData.status === postStatusConfig.CLIENT_PENDING"
                    >Start Submission Review</v-btn>
                    <v-btn
                      color="secondary"
                      @click="openChooseDateDialog"
                      v-if="postData.propose_dates && postData.status !== postStatusConfig.APPROVE"
                    >
                      <v-icon right>check</v-icon> Approve Date
                    </v-btn>
                    <v-spacer></v-spacer>
                  </v-card-actions>
                  <!-- Comments CS <=> Influencer -->
                  <v-flex v-if="cs_inf_chatbox">
                    <v-expansion-panels>
                      <v-expansion-panel>
                        <v-expansion-panel-header>
                          <div class="subtitle-1">
                            <v-icon color="secondary">message</v-icon>
                            {{conversationWithName}} ({{messages.length}})
                          </div>
                        </v-expansion-panel-header>
                        <v-expansion-panel-content>
                          <v-container>
                            <chat-box
                              :label="commentToLabel"
                              :messages="messages"
                              @commented="sendMessage"
                            />
                          </v-container>
                        </v-expansion-panel-content>
                      </v-expansion-panel>
                    </v-expansion-panels>
                  </v-flex>
                  <!-- Comments Client <=> Client -->
                  <v-flex v-if="client_inf_chatbox">
                    <v-expansion-panels>
                      <v-expansion-panel>
                        <v-expansion-panel-header>
                          <div class="subtitle-2">
                            <v-icon color="secondary">message</v-icon>
                            Internal Notes (for your internal communication only, neither Kobe nor the creators would have access to these notes)
                          </div>
                        </v-expansion-panel-header>
                        <v-expansion-panel-content>
                          <v-container>
                            <chat-box
                              label=""
                              :messages="clientMessages"
                              @commented="sendClientMessage"
                              :isClient="isClient"
                              type="internal_notes"
                            />
                          </v-container>
                        </v-expansion-panel-content>
                      </v-expansion-panel>
                    </v-expansion-panels>
                  </v-flex>

                  <!-- Post Abuse Summary -->
                  <!-- <v-flex v-if="overRideBySuperAdmin ? overRideBySuperAdmin : postAbuseHistory">
                    <v-expansion-panels>
                      <v-expansion-panel v-for="(item, i) in clientReportAbuse" :key="i">
                        <v-expansion-panel-header>
                          <div class="subtitle-1" color="red lighten-4">
                            <v-icon color="deep-orange">report_problem</v-icon>
                            Reported Abuse
                          </div>
                        </v-expansion-panel-header>
                        <v-expansion-panel-content>
                          <v-card>
                            <v-card-text class="grey lighten-3">
                              <h4>Reasons for Non-Approval</h4>
                              <p>
                                <ol>
                                  <li v-for="r in item.reasons" :key="r">{{r}}</li>
                                </ol>
                              </p>
                              <h4>Comments for Abuse:</h4>
                              <p>
                                {{item.comment}}
                              </p>
                              <div class="text-xs-right caption font-weight-italic">{{formatDate(item.date)}}</div>
                            </v-card-text>
                          </v-card>
                        </v-expansion-panel-content>
                      </v-expansion-panel>
                    </v-expansion-panels>
                  </v-flex> -->
                  <!-- Post Rate Review By Client -->
                  <v-flex v-if="postReviewApproved" centered>
                    <v-card v-if="postData.clientAcceptReview">
                      <v-card-text>
                        <v-layout row wrap>
                          <v-flex md6 xs12 class="text-center">
                            <p class="subtitle-1">Rating on influencer's quality of work</p>
                            <v-rating
                              class="ma-5"
                              v-model="postData.clientAcceptReview.rate"
                              color="secondary"
                              size="30"
                              readonly dense
                            ></v-rating>
                            <p class="font-weight-bold">{{postData.clientAcceptReview.rate}}/5 stars Rated</p>
                          </v-flex>
                          <v-flex md6 xs12 class="text-center">
                            <div class="subtitle-1" max-width="100">
                              <p>Comment for Influencer</p>
                              <v-textarea text filled readonly v-model="postData.clientAcceptReview.comment"></v-textarea>
                            </div>
                          </v-flex>
                        </v-layout>
                      </v-card-text>
                    </v-card>
                  </v-flex>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn @click.native="closeModal" text>Close</v-btn>
                </v-card-actions>
              </v-card>
            </v-col>
            <v-col md="3" xs="12" v-if="(overRideBySuperAdmin || postAbuseHistory) && clientReportAbuse.length > 0">
              <v-expansion-panels class="report-abuse-section">
                <v-expansion-panel v-for="(item, i) in clientReportAbuse" :key="i">
                  <v-expansion-panel-header>
                    <div class="subtitle-1" color="red lighten-4">
                      <v-icon color="deep-orange">report_problem</v-icon>
                      Reported Abuse
                    </div>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content class="report-abuse-expansion">
                    <v-card>
                      <v-card-text class="grey lighten-3 pl-1 pr-1">
                        <h4>Reasons for Non-Approval</h4>
                        <p>
                          <ol>
                            <li v-for="r in item.reasons" :key="r">{{r}}</li>
                          </ol>
                        </p>
                        <h4>Comments for Abuse:</h4>
                        <!-- <p>
                          {{item.comment}}
                        </p> -->
                        <!-- <v-textarea
                          readonly
                          filled
                          auto-grow
                          rows="4"
                          v-model="item.comment"
                          counter
                          >
                        </v-textarea> -->
                        <!-- <textarea style="max-height: 300px;min-height: 200px;overflow-y: auto;" rows="4" readonly>{{item.comment}}</textarea> -->
                        <div style="max-height: 300px;min-height: 200px;overflow-y: auto;" v-html="renderHTML(item.comment)">
                        </div>
                        <div class="text-xs-right caption font-weight-italic">{{formatDate(item.date)}}</div>
                        <div v-if="item.files">
                          <h4>Uploaded Screenshots:</h4>
                          <p>
                            <ol>
                              <li v-for="(f, index) in item.files" :key="index">
                                <a :href="f.url" target="_blank" v-if="f.url">{{utilsFunc.getFileNameFromURL(f.url)}}</a>
                              </li>
                            </ol>
                          </p>
                        </div>
                      </v-card-text>
                    </v-card>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>
            </v-col>
            <!-- <v-col md="4" xs="12" v-if="overRideBySuperAdmin ? overRideBySuperAdmin : postHistory">
              <v-card height="100%">
                <v-card-title class="title">
                  Draft History
                </v-card-title>
                <v-card-text>
                  <v-list dense>
                    <template v-for="(hpost, i) in postHistoryData">
                      <v-list-item
                        :key="hpost._id + i"
                        @click="switchPostView(hpost)"
                      >
                        <v-list-item-content>
                          <v-list-item-title v-if="hpost.editedBy">
                            {{hpost.editedBy.name}}
                          </v-list-item-title>
                          <v-list-item-title>
                            {{ hpost.isMain == null ? `${formatDate(hpost.createdAt)} (Active)` : formatDate(hpost.createdAt)}}
                          </v-list-item-title>
                        </v-list-item-content>
                        <v-list-item-action v-if="hpost._id === postData._id">
                          <v-icon color="green">check_circle</v-icon>
                        </v-list-item-action>
                        <v-list-item-action v-if="hpost._id !== postData._id && hpost._id === post.mainPost._id">
                          <v-tooltip float-right>
                            <template v-slot:activator="{ on }">
                              <v-icon color="grey" v-on="on">check_circle_outline</v-icon>
                            </template>
                            <span>Influencer & Client will see this version of draft.</span>
                          </v-tooltip>
                        </v-list-item-action>
                      </v-list-item>
                    </template>
                  </v-list>
                </v-card-text>
                <v-card-actions>
                  <v-btn block class="secondary" @click="setPrimaryPost(postData._id)">
                    Change to this version
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-col> -->
          </v-row>
          <!-- <v-dialog
            v-model="mediaViewerDialog"
            max-width="700"
            >
            <v-card>
              <v-card-title
                class="grey lighten-2"
                primary-title
              >
                <v-spacer></v-spacer>
                <v-icon @click="mediaViewerDialog = false">close</v-icon>
              </v-card-title>
              <v-card-text class="text-center" v-if="mediaItem.publicID && mediaItem.isvideo">
                <custom-media-v2
                  :media="campaignHelper.customPostMediaConfig(mediaItem, { videoDownload: true })"
                />
              </v-card-text>
              <v-card-text class="text-center" v-else>
                <v-img :src="mediaItem" v-if="!videoPlayer"></v-img>
                <video width="300" controls v-if="videoPlayer">
                  <source :src="mediaItem" type="video/mp4">
                  Your browser does not support HTML5 video.
                </video>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <a :href="mediaItem" download target="_blank">
                  <v-btn><v-icon float-left>save_alt</v-icon>Download</v-btn>
                </a>
              </v-card-actions>
            </v-card>
          </v-dialog> -->
          <post-media-viewer-modal
            :viewerValue="mediaViewerDialog"
            :media="mediaItem"
            :videoPlayer="videoPlayer"
            @closed="closeMediaViewerModal"
          />
        </v-container>
      </v-card>
    </v-dialog>
    <view-post-detail-modal
      :campaignName="postData.campaignName"
      :submittedCampaignName="postData.submittedCampaignName"
      :postDetails="postDetails"
      :postReviewApproved="postReviewApproved"
      :influencerData="influencerData"
      :mappedInfluencerData="mappedInfluencerData"
      :postAbuseHistory="postAbuseHistory"
      :clientReportAbuse="clientReportAbuse"
      :detailValue="viewPostDetailDialog"
      :userObj="userObj"
      @detailClosed="closeDetailModal"
      v-if="postData !== null"
    />
    <!-- propose date modal -->
    <propose-date-modal
      :post="postData"
      :proposeDialogValue="proposeDateDialog"
      @proposeClosed="closeProposeDateModal"
    />
    <!-- client choose date modal -->
    <client-choose-date-modal
      :post="postData"
      :ChooseDateDialogValue="chooseDateDialog"
      @chooseDateClosed="closeChooseDateModal"
    />
    <!-- confirm date dialog -->
    <v-dialog
      ref="dateDialog"
      v-model="changeConfirmDate"
      :return-value.sync="confirmDate"
      persistent
      width="290px"
    >
      <v-date-picker v-model="confirmDate" scrollable :min="post ? post.postDate : ''">
        <v-spacer></v-spacer>
        <v-btn text color="secondary" @click="changeConfirmDate = false">Cancel</v-btn>
        <v-btn
          text
          color="secondary"
          @click="saveConfirmDate"
        >OK</v-btn>
      </v-date-picker>
    </v-dialog>
    <!-- propose date modal -->
    <propose-date-modal
      :post="postData"
      :proposeDialogValue="proposeDateDialog"
      @proposeClosed="closeProposeDateModal"
    />
  </div>
</template>
<style scoped>
  .caption-label {
    font-size: 14px;
    color: #3F3FFF;
    font-weight: 400;
  }

  .caption-text {
    font-size: 12px;
    font-weight: 600;
    margin-bottom:20px;
    padding:10px;
    background-color: rgb(0, 0, 0, 0.06);
    display: flex;
    align-items: center;
    gap: 4px;
  }
  .caption-text__value {
    min-width: 0;
    flex: 1;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
</style>
<style>
  .v-application .v-dialog.view-post-modal > .v-card > .view-post-modal__body {
    flex: 1 1 auto;
    min-height: 0;
    overflow-x: hidden;
    overflow-y: auto;
  }

  .report-abuse-expansion .v-expansion-panel-content__wrap {
    padding-left: 4px!important;
    padding-right: 4px!important;
  }
</style>
<script>
import { isMissingPostMedia } from './postMedia';
import DOMPurify from 'dompurify';
import config from '@/config';
import utils from '@/utils'
import PostAPI from './postApi';
import postConfig from './postConfig';
import moment from 'moment';
import chatBox from './PostChatBox.vue';
import ViewPostDetailModal from './ViewPostDetailModal.vue';
import PostMediaViewerModal from './PostMediaViewerModal.vue';
import ProposeDateModal from './ProposeDateModal.vue';
import ClientChooseDateModal from './ClientChooseDateModal.vue';
import btnDownload from '@/components/scoped/custom/BtnDownload.vue';
import CustomMediaV2 from '../../scoped/custom/CustomMediaV2';
import campaignHelper from '../Campaign/campaignHelper';
import campaignConfig from '../Campaign/config';
import { mapState } from 'vuex';
export default {
  props: {
    post: Object,
    value: Boolean,
    csActions: Boolean,
    proposeDateActions: Boolean,
    saleActions: Boolean,
    clientActions: Boolean,
    influencerActions: Boolean,
    cs_inf_chatbox: Boolean,
    client_inf_chatbox: Boolean,
    postAbuseHistory: Boolean,
    postReviewApproved: Boolean,
    postHistory: Boolean,
    userObj: Object
  },
  components: {
    chatBox,
    btnDownload,
    CustomMediaV2,
    ViewPostDetailModal,
    PostMediaViewerModal,
    ProposeDateModal,
    ClientChooseDateModal
  },
  data() {
    return {
      utilsFunc: utils.func,
      postData: null,
      showSuggestEditBox: false,
      suggestionText: null,
      images: [],
      postStatusDisplay: '',
      viewPostDetailDialog: false,
      mediaViewerDialog: false,
      proposeDateDialog: false,
      chooseDateDialog: false,
      changeConfirmDate: false,
      showConfirmDateFromRoute: false,
      confirmDate: '',
      mediaItem: '',
      videoPlayer: false,
      messages: [],
      clientMessages: [],
      influencerData: null,
      postHistoryData: [],
      clientReportAbuse: [],
      clientReportAbuseData: [],
      overRideBySuperAdmin: false,
      influencerRole: config.userRoles.INFLUENCER,
      campaignHelper,
      isIGCutOff: false,
      isIGStory: false,
      isTikTokCutOff: false,
      postTypes: postConfig.postTypes,
      campaignTypes: campaignConfig.campaignType
    }
  },
  watch: {
    post(newVal) {
      this.clearData();
      this.postData = newVal.mainPost || null;
      this.images = newVal.mainPost.images || newVal.images
      this.messages = newVal.comments
      this.clientMessages = newVal.clientComments
      if (this.currentUserRole <= this.userRoles.AD_STRATEGIST && newVal.mainPost.mapInfluencer) {
        this.mappedInfluencerData = newVal.mainPost.mapInfluencer
      } else {
        this.mappedInfluencerData = null
      }
      this.influencerData = newVal.influencer
      this.clientReportAbuseData = newVal.reportAbuse
      this.clientReportAbuse = newVal.reportAbuse ? newVal.reportAbuse.filter(item => newVal.mainPost.draftId ? (item.draftPostId === newVal.mainPost.draftId) : false) : []
      this.loadHistoryPosts(newVal)
      this.loadPostStatusDisplay(newVal)
      if (this.currentUserRole === this.userRoles.SUPER_ADMIN_HIGH) {
        this.overRideBySuperAdmin = true;
      }
      this.viewPostDetailDialog = false;
      if (!this.postData.callToActionLinks) {
        this.loadCampaign(this.postData)
      } else {
        if (this.postData.campaignID) {
          this.$store.dispatch('campaign/getCampaignDetail', this.postData.campaignID)
        }
      }
      this.setMultipleInfs(this.postData)
      if (this.$route.query.confirmDate && !this.showConfirmDateFromRoute) {
        this.showConfirmDateFromRoute = true
        this.invokeConfirmDateChange()
      }
    },
    value(newVal) {
      if (newVal) {
        /* eslint-env jquery */
        setTimeout(() => {
          let modalHeight = $('.view-post-modal').height()
          let reposeAbuseHeight = modalHeight - 135
          var element = document.querySelector('.report-abuse-section');
          if (element) {
            element.setAttribute('style', `max-height:${reposeAbuseHeight}px!important;overflow-y:auto;padding:2px;`);
          }
        }, 1000)
      }
    }
  },
  methods: {
    isMissingMedia(media) {
      return isMissingPostMedia(media)
    },
    getVideoLink(link) {
      try {
        const url = new URL(link)
        return ['http:', 'https:'].includes(url.protocol) ? url.href : ''
      } catch (error) {
        return ''
      }
    },
    getPostTypeMeta(type) {
      return this.postTypes.find(postType => postType.type === type) || {}
    },
    changeCutOff(type) {
      if (type === 'IG' && this.isIGCutOff) {
        this.isIGCutOff = true
        this.isIGStory = false
        this.isTikTokCutOff = false
      } else if (type === 'IGStory' && this.isIGStory) {
        this.isIGCutOff = false
        this.isIGStory = true
        this.isTikTokCutOff = false
      } else if (type === 'tiktok' && this.isTikTokCutOff) {
        this.isIGCutOff = false
        this.isIGStory = false
        this.isTikTokCutOff = true
      } else {
        this.isIGCutOff = false
        this.isIGStory = false
        this.isTikTokCutOff = false
      }
    },
    clearData() {
      this.postData = null
      this.images = null
      this.messages = null
      this.mappedInfluencerData = null
      this.influencerData = null
      this.clientReportAbuseData = null
      this.clientReportAbuse = null
      this.postHistoryData = []
      this.postStatusDisplay = null
    },
    loadPostStatusDisplay(newPost) {
      let currentUserRole = this.userObj.role
      if (currentUserRole === config.userRoles.CLIENT) {
        this.postStatusDisplay = postConfig.postStatusDisplayForClient[newPost.mainPost.status]
      } else if (currentUserRole === config.userRoles.INFLUENCER) {
        this.postStatusDisplay = postConfig.postStatusDisplayForInfluencer[newPost.mainPost.status]
      } else if (currentUserRole === config.userRoles.AD_STRATEGIST || currentUserRole === config.userRoles.ACCOUNT_MANAGER) {
        this.postStatusDisplay = postConfig.postStatusDisplayForCS[newPost.mainPost.status]
      } else {
        this.postStatusDisplay = config.postStatusDisplayInternal[newPost.mainPost.status].display
      }
    },
    paserImageUrl(url) {
      if (!url) return '/static/img/avatar/user.png'
      var newUrl = url.replace('http://imgp.socapi.icu/', location.origin + '/socapi').replace('https://imgp.socapi.icu/', location.origin + '/socapi')
      return newUrl
    },
    paserAudienceImageUrl(audience) {
      if (audience.user_profile !== undefined) {
        var newUrl = audience.user_profile.picture;
        return newUrl;
      } else {
        return '/static/img/avatar/user.png';
      }
    },
    loadHistoryPosts(newPost) {
      if (newPost.history) {
        this.postHistoryData = []
        let postHistoryArray = newPost.history
        postHistoryArray.push(newPost.mainPost)
        this.postHistoryData = postHistoryArray.sort((a, b) => moment(a.createdAt) - moment(b.createdAt))
      }
    },
    setPrimaryPost(postID) {
      if (postID === this.post.mainPost._id) {
        this.$swal(`The draft is already set as Primary Post.`)
        return
      } else {
        PostAPI
          .setAsMainPost(postID)
          .then((response) => {
            this.closeModal()
            this.postData._id = this.post._id
            this.$emit('mainPostChanged', this.postData)
          })
          .catch(error => {
            this.$swal({
              title: `Error in submitting primary post`,
              type: 'error',
              content: error
            });
          })
      }
    },
    switchPostView(hpost) {
      this.postData = hpost
      this.images = hpost.images
      this.clientReportAbuse = this.clientReportAbuseData.filter(item => hpost.draftId === item.draftPostId || hpost._id === item.draftPostId)
    },
    formatDate(date) {
      return moment(date).format('DD-MM-YYYY, HH:mm');
    },
    release() {
      this.$emit('saleReleased', this.postData)
    },
    directRelease() {
      this.$emit('directReleased', this.postData)
    },
    approve() {
      this.$emit('csApproved', this.postData)
    },
    edit() {
      this.$emit('editPost', this.postData)
      this.closeModal()
    },
    editLiveDate() {
      this.$emit('editLiveDate', this.postData)
      this.closeModal()
    },
    closeModal() {
      this.$emit('input')
      this.pauseVideo()
    },
    closeMediaViewerModal() {
      this.mediaViewerDialog = false
    },
    closeDetailModal() {
      this.viewPostDetailDialog = false
    },
    pauseVideo() {
      let video = document.getElementById('previewVideo');
      if (video) { video.pause(); }
    },
    viewMedia(media, isVideo) {
      if (isVideo) {
        this.videoPlayer = true
      } else {
        this.videoPlayer = false
      }
      this.mediaItem = media
      this.mediaViewerDialog = false
      this.mediaViewerDialog = true
    },
    sendMessage: function(message) {
      if (!message) {
        this.$swal(`Comment can't be empty`)
      } else {
        PostAPI.csComment(this.postData._id, message)
          .then((comment) => {
            this.suggestionText = null;
            this.showSuggestEditBox = false;
            this.postData.cs_comments ? '' : this.postData.cs_comments = []
            this.postData.cs_comments.push(
              {
                comment: message,
                commentator: this.userObj.firstName,
                createdAt: moment()
              }
            )
            this.messages.push(comment)
          })
        .catch(error => {
          this.$swal({
            title: `Can't Make Comments now, try again later`,
            type: 'error',
            content: error
          });
        });
      }
    },
    sendClientMessage: function(message) {
      if (!message) {
        this.$swal(`Comment can't be empty`)
      } else {
        PostAPI.clientComment(this.postData._id, message)
          .then((comment) => {
            this.postData.client_comments ? '' : this.postData.client_comments = []
            this.postData.client_comments.push(
              {
                comment: message,
                commentator: this.userObj.firstName,
                createdAt: moment()
              }
            )
            this.clientMessages.push(comment)
          })
        .catch(error => {
          this.$swal({
            title: `Can't Make Comments now, try again later`,
            type: 'error',
            content: error
          });
        });
      }
    },
    viewPostDetails() {
      this.postDetails = Object.assign([], this.postHistoryData)
      for (let history of this.postDetails) {
        if (this.currentUserRole <= this.userRoles.AD_STRATEGIST && history.mapInfluencer) {
          history.mappedInfluencerData = history.mapInfluencer
        } else {
          history.mappedInfluencerData = null
        }
        history.influencerData = history.influencer
        // history.clientReportAbuseData = history.reportAbuse
        // history.clientReportAbuse = history.reportAbuse ? history.reportAbuse.filter(item => history.mainPost.draftId ? (item.draftPostId === history.mainPost.draftId) : false) : []
        history.clientReportAbuse = this.clientReportAbuseData.filter(item => history.draftId === item.draftPostId || history._id === item.draftPostId)
        if (this.currentUserRole === this.userRoles.SUPER_ADMIN_HIGH) {
          history.overRideBySuperAdmin = true;
        }
      }
      this.viewPostDetailDialog = false
      this.viewPostDetailDialog = true
    },
    async markMetadataTag(ids) {
      this.$swal({
        title: 'Double Check!',
        text: 'Are you sure you want to mark as metadata tagged?',
        confirmButtonText: 'Confirm',
        type: 'info',
        showCancelButton: true,
        showCloseButton: true
      }).then(async (result) => {
        if (result.value) {
          let data = ids.map(postID => {
            return Object.assign({}, {
              id: postID,
              metadataTagged: true
            })
          })
          // Submit request to save post data
          await this.$store.dispatch('post/updatePostByIds', data)
          this.isLoading = false;
          if (!this.postUpdateStatus) {
            this.$swal({
              text: 'Error Metadata Tag.',
              type: 'error'
            });
            return
          }
          // Show success message
          this.$swal({
            text: 'Successfully Saved Metadata Tag.',
            type: 'success'
          });
          this.closeModal()
        }
      })
    },
    abuseResolvePosts(postIds) {
      this.$swal({
        title: 'Are you sure?',
        text: 'Upon Confirmation, the latest edited version will be send to AM as abuse resolved.',
        type: 'question',
        showCancelButton: true,
        confirmButtonText: 'Agree',
        cancelButtonText: 'Cancel',
        showCloseButton: true,
        showLoaderOnConfirm: true,
        preConfirm: login => {
          return PostAPI.abuseResolvePost(postIds)
            .then(data => {
              return data;
            })
            .catch(error => {
              console.error(error);
              this.$swal({
                title: 'Error in abuse resolving Post, please try again',
                type: 'error'
              });
            });
        },
        allowOutsideClick: () => !this.$swal.isLoading()
      }).then(result => {
        if (result.value) {
          // Show success message
          this.$swal({
            title: 'Success',
            text: 'The abuse resolved draft is now waiting for release from AM.\nOnced released, it will sent to client.',
            type: 'success'
          });
          // Reload Page
          // this.$router.push({ path: '/posts/pending-kobe' });
          this.$emit('input')
          this.$emit('postUpdated')
          this.closeModal()
        } else {
          // Do nothing for now
        }
      });
    },
    releaseAbuseResolvedPosts(postIds) {
      this.$swal({
        title: 'Are you sure?',
        html: '<b>Upon confirmation, the post will be released to client as abuse resolved.</b>',
        type: 'question',
        showCancelButton: true,
        confirmButtonText: 'Agree',
        cancelButtonText: 'Cancel',
        showCloseButton: true,
        showLoaderOnConfirm: true,
        preConfirm: login => {
          return PostAPI.releaseAbuseResolvePost(postIds)
            .then(data => {
              return data;
            })
            .catch(error => {
              console.error(error);
              this.$swal({
                title: 'Error in releasing Post, please try again',
                type: 'error'
              });
            });
        },
        allowOutsideClick: () => !this.$swal.isLoading()
      }).then(result => {
        if (result.value) {
          // Show success message
          this.$swal({
            title: 'Success',
            text: 'The abuse resolved draft is sent to client.',
            type: 'success'
          });
          // Reload Page
          // this.$router.push({ path: '/posts/pending-kobe' });
          this.$emit('input')
          this.$emit('postUpdated')
          this.closeModal()
        } else {
          // Do nothing for now
        }
      });
    },
    isIncludeInAbuseReport(reportedDraftId, clientReportArr) {
      if (!clientReportArr) return false;
      let tmpArr = clientReportArr.map(item => item.postId);
      let draftPostTmpArr = clientReportArr.map(item => item.draftPostId);
      return tmpArr.includes(reportedDraftId) || draftPostTmpArr.includes(reportedDraftId);
    },
    openProposeDateDialog() {
      this.proposeDateDialog = true
    },
    closeProposeDateModal() {
      this.proposeDateDialog = false
    },
    openChooseDateDialog() {
      this.chooseDateDialog = true
    },
    closeChooseDateModal() {
      this.chooseDateDialog = false
    },
    invokeConfirmDateChange() {
      this.confirmDate = this.postData.postDate
      this.changeConfirmDate = true
    },
    async saveConfirmDate() {
      this.$refs.dateDialog.save(this.confirmDate)
      let saveData = [
        {
          id: this.post._id,
          requestDate: null,
          propose_dates: null,
          postDate: this.confirmDate,
          dateConfirmed: true,
          status: this.postStatusConfig.APPROVE
        }
      ]
      await this.$store.dispatch('post/updatePostByIds', saveData)
      if (this.postUpdateStatus) {
        // Show success message
        this.$swal({
          text: 'Successfully confirmed.',
          type: 'success'
        });
        let payload = {
          id: this.post._id,
          appLink: window.location.protocol + '//' + window.location.host + '/posts/internal/all-posts?campaignID=' + this.post.mainPost ? this.post.mainPost.campaignID : null + '&postID=' + this.post._id
        }
        // if not request date and CS team directly confirm post
        // if (!this.postData.requestDate && this.postData.status !== this.postStatusConfig.APPROVE) {
        //   await this.$store.dispatch('post/sendReviseDateEmail', {
        //     id: this.post._id,
        //     type: 'client'
        //   })
        // }
        // send to inf for accepted post
        await this.$store.dispatch('post/sendClientAcceptPost', payload)
        // if request date exists and in approved post, send to propose date accepted client email
        if (this.postData.requestDate && this.postData.status === this.postStatusConfig.APPROVE) {
          await this.$store.dispatch('post/sendProposeDateAcceptedToClient', {
            id: this.post._id,
            postDate: this.confirmDate
          })
        }
        this.closeModal()
        if (this.postData.status === this.postStatusConfig.APPROVE) {
          this.$emit('postUpdated')
        } else {
          this.$router.push({path: '/posts/internal/approved'})
        }
      }
    },
    async setMultipleInfs(postData) {
      let infs = []
      await this.$store.dispatch('influencer/getInfluencerDetail', {
        id: postData.influencerID
      })
      if (this.infDetail.instagram) {
        infs.push({
          handle: this.infDetail.instagram.instagramHandle,
          instagramID: this.infDetail.instagram.instagramID,
          picture: this.infDetail.audience ? this.infDetail.audience.user_profile.picture : this.infDetail.instagram.picture,
          instagram: true
        })
        if (postData.submitedBy && !this.mappedInfluencerData) {
          if (!this.influencerData.platform || postData.submitedBy.instagramHandle) {
            infs[infs.length - 1].default = true
            this.postData.defaultInf = infs[infs.length - 1]
          }
        }
      }
      if (this.infDetail.tiktok) {
        infs.push({
          handle: this.infDetail.tiktok.tiktokHandle,
          tiktokID: this.infDetail.tiktok.tiktokID,
          picture: this.infDetail.tiktokaudience ? this.infDetail.tiktokaudience.user_profile.picture : this.infDetail.tiktok.picture,
          tiktok: true
        })
        if (postData.submitedBy && !this.mappedInfluencerData) {
          if (!this.influencerData.platform || postData.submitedBy.tiktokHandle) {
            infs[infs.length - 1].default = true
            this.postData.defaultInf = infs[infs.length - 1]
          }
        }
      }
      if (this.infDetail.youtube) {
        infs.push({
          handle: this.infDetail.youtube.youtubeHandle,
          youtubeID: this.infDetail.youtube.youtubeID,
          picture: this.infDetail.youtubeaudience ? this.infDetail.youtubeaudience.user_profile.picture : this.infDetail.youtube.picture,
          youtube: true
        })
        if (postData.submitedBy && !this.mappedInfluencerData) {
          if (!this.influencerData.platform || postData.submitedBy.youtubeHandle) {
            infs[infs.length - 1].default = true
            this.postData.defaultInf = infs[infs.length - 1]
          }
        }
      }
      if (this.infDetail.linkedin) {
        infs.push({
          handle: this.infDetail.linkedin.linkedinHandle,
          linkedinID: this.infDetail.linkedin.linkedinID,
          picture: this.infDetail.linkedin.profilePicture,
          linkedin: true
        })
        if (postData.submitedBy && !this.mappedInfluencerData &&
          postData.submitedBy.linkedinHandle) {
          infs[infs.length - 1].default = true
          this.postData.defaultInf = infs[infs.length - 1]
        }
      }
      this.postData.influencers = infs
      this.postData = utils.func.refreshJSON(this.postData)
    },
    async changePlatform(inf, index) {
      this.isLoading = true;
      await this.$store.dispatch('post/updatePostOwner', {
        postID: this.postData._id,
        owner: inf,
        type: 'submitted_by'
      })
      if (this.postUpdateStatus) {
        this.postData.defaultInf = this.postData.influencers[index]
        this.postData = utils.func.refreshJSON(this.postData)
      }
      this.isLoading = false;
      this.$emit('postUpdated')
    },
    async loadCampaign(post) {
      await this.$store.dispatch('campaign/getCampaignDetail', post.campaignID)
      let hashTags = campaignHelper.getMandatoryHashtagMentions(this.campaign)
      this.postData.mandatoryHashtag = hashTags
      this.postData.callToActionLinks = this.campaign.callToActionLinks || ''
      this.postData = utils.func.refreshJSON(this.postData)
    },
    async changePostType(typeVal) {
      this.isLoading = true;
      let updateData = Object.assign({}, typeVal)
      updateData.postID = this.postData._id
      await this.$store.dispatch('post/updatePostTypes', updateData)
      if (this.postUpdateStatus) {
        this.postData.type = typeVal.type
        this.postData.typeName = typeVal.typeName
      }
      this.isLoading = false
    },
    renderHTML(text) {
      if (text !== undefined && text !== null && text !== '') {
        if (/<[a-z][\s\S]*>/i.test(text)) {
          // Rich-text remarks/comments are user-authored HTML rendered via
          // v-html — sanitize with DOMPurify's allowlist so stored markup
          // (e.g. onerror handlers) can't execute in another user's session.
          return DOMPurify.sanitize(text);
        }
        return text.replace(/\n/g, '<br>');
      }
      return '-';
    }
  },
  computed: {
    ...mapState({
      campaign: state => state.campaign.campaignDetail,
      postUpdateStatus: state => state.post.updated,
      infDetail: state => state.influencer.infDetail
    }),
    currentUserRole: function() {
      return Number(this.$store.state.user.role);
    },
    postStatusConfig: function() {
      return config.postStatus;
    },
    userRoles: function() {
      return config.userRoles;
    },
    commentToLabel() {
      if (this.currentUserRole === config.userRoles.INFLUENCER) {
        return 'Message to Content Strategist';
      } else if (this.currentUserRole === config.userRoles.AD_STRATEGIST) {
        return 'Message to Influencer';
      } else {
        return '';
      }
    },
    conversationWithName() {
      if (this.currentUserRole === config.userRoles.INFLUENCER) {
        return 'Comments';
      } else if (this.currentUserRole === config.userRoles.AD_STRATEGIST) {
        return 'Comments';
      } else {
        return 'Conversations between KOBE and Creator';
      }
    },
    isVideoLink() {
      return this.postData.type === 'story' ||
      this.postData.type === 'video' ||
      this.postData.type === 'reel' ||
      this.postData.type === 'tiktok' ||
      this.postData.type === 'youtube' ||
      this.postData.type === 'facebook'
    },
    isRemark() {
      return this.currentUserRole !== config.userRoles.INFLUENCER
    },
    isHashTag() {
      return this.postData.mandatoryHashtag && ((this.currentUserRole <= config.userRoles.AD_STRATEGIST || this.currentUserRole === config.userRoles.ACCOUNT_MANAGER) ||
      this.currentUserRole === config.userRoles.INFLUENCER && this.postData.status === this.postStatusConfig.APPROVE)
    },
    isCallToActionLinks() {
      return this.postData.callToActionLinks && ((this.currentUserRole <= config.userRoles.AD_STRATEGIST || this.currentUserRole === config.userRoles.ACCOUNT_MANAGER) ||
      this.currentUserRole === config.userRoles.INFLUENCER && this.postData.status === this.postStatusConfig.APPROVE)
    },
    isClient: function () {
      return Number(this.$store.state.user.role) === config.userRoles.CLIENT;
    },
    mainViewGrid() {
      let col = 12
      if (this.postAbuseHistory && this.clientReportAbuse.length > 0) col -= 3
      if (this.postAbuseHistory && this.postHistoryData.length > 0) col -= 3
      return col
    },
    captionLabel() {
      return this.postData.type === 'story' ? 'Story Caption' : 'Caption'
    },
    overlayType() {
      if (this.isIGCutOff) {
        return 'IG'
      }
      if (this.isIGStory) {
        return 'IGStory'
      }
      if (this.isTikTokCutOff) {
        return 'TikTok'
      }
      return ''
    },
    showCutOffView() {
      if (Array.isArray(this.images)) {
        let totalMedias = this.images.length
        let totalImgs = this.images.filter(i => !i.isvideo).length
        if (totalMedias === totalImgs) {
          return false
        }
      }
      return true
    }
  }
};
</script>
<style>
.kobe-remark-display {
  min-height: 96px;
  padding: 12px 16px;
  background: #f5f5f5;
  border-radius: 4px;
  overflow-wrap: anywhere;
}

.kobe-remark-display__label {
  margin-bottom: 8px;
  color: rgba(0, 0, 0, 0.6);
  font-size: 12px;
}
</style>



// WEBPACK FOOTER //
// ViewPostModal.vue?5ab858da